var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from 'react';
import _merge from 'lodash.merge';
import ECharts from '../ECharts';
import Tooltip from '../components/Tooltip';
import Map from '../series/Map';
import VisualMap from '../components/VisualMap';
import { EChartsContext } from '../constants';
import { is } from '../utils';
const mapVisualMapColors = [
    'rgb(8, 132, 204)',
    'rgba(8, 132, 204, .8)',
    'rgba(8, 132, 204, .6)',
    'rgba(8, 132, 204, .4)',
    'rgba(8, 132, 204, .3)'
];
function MapChart(_a, ref) {
    var { name, data = [], visualMap: shouldShowVisualMap = true, children } = _a, props = __rest(_a, ["name", "data", "visualMap", "children"]);
    function renderDefaultMap() {
        return React.createElement(Map, Object.assign({ name: name, data: data }, props));
    }
    const components = Children.toArray(children);
    const compVisualMap = components.find(comp => is(comp, 'visualMap'));
    const visualMapProps = {
        show: shouldShowVisualMap !== false,
        type: 'piecewise',
        inRange: {
            color: [...mapVisualMapColors].reverse()
        },
        controller: {
            symbol: 'rect'
        }
    };
    const map = components.find(comp => is(comp, 'map'));
    return (React.createElement(EChartsContext.Provider, { value: { chartType: 'map', dataName: name, chartData: data } },
        React.createElement(ECharts, Object.assign({ ref: ref }, props),
            React.createElement(Tooltip, null),
            !compVisualMap && React.createElement(VisualMap, Object.assign({}, visualMapProps)),
            !map && renderDefaultMap(),
            components.map((child) => {
                if (child.type === VisualMap) {
                    return React.cloneElement(child, _merge(visualMapProps, child.props));
                }
                return child;
            }))));
}
export default React.forwardRef(MapChart);
//# sourceMappingURL=MapChart.js.map